var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgContactImg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-simple--inject-1--inject-92"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M306,61.88S241.76,44.67,184.05,85s-82,113.17-103.18,171.63-.68,114.53,48.31,136.88,77.08-18.73,142.23-25.9,83.59.81,134.35-40.74,52.42-130.09,3.64-191.55S306,61.88,306,61.88Z",
    style: {
      fill: "#BE9C79"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306,61.88S241.76,44.67,184.05,85s-82,113.17-103.18,171.63-.68,114.53,48.31,136.88,77.08-18.73,142.23-25.9,83.59.81,134.35-40.74,52.42-130.09,3.64-191.55S306,61.88,306,61.88Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plants--inject-1--inject-92"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M126.71,277.91s0-3.46-4.86-8.32-8-7.63-8-7.63-2.43,8,2.08,12.83a85.33,85.33,0,0,0,10.75,9.37Z",
    style: {
      fill: "#BE9C79"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.66,299.58s0-3.47-4.85-8.33-8-7.63-8-7.63-2.43,8,2.08,12.83a85.33,85.33,0,0,0,10.75,9.37Z",
    style: {
      fill: "#BE9C79"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.4,283.82s.37-3.45,5.71-7.76,8.74-6.75,8.74-6.75,1.57,8.19-3.42,12.54A85,85,0,0,1,125.75,290Z",
    style: {
      fill: "#BE9C79"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.89,309.4s.73-3.39,6.49-7.12,9.4-5.79,9.4-5.79.71,8.31-4.72,12.12a85.59,85.59,0,0,1-12.48,6.9Z",
    style: {
      fill: "#BE9C79"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.49,337.3s0-3.47,4.86-8.33,8-7.63,8-7.63,2.42,8-2.09,12.84a85,85,0,0,1-10.75,9.36Z",
    style: {
      fill: "#BE9C79"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.41,344.1s.49-3.43-3.62-8.93-6.82-8.68-6.82-8.68-3.53,7.55.24,13a85.35,85.35,0,0,0,9.31,10.79Z",
    style: {
      fill: "#BE9C79"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.62,364.28s0-3.47,4.86-8.32,8-7.63,8-7.63,2.42,8-2.08,12.83a85.06,85.06,0,0,1-10.76,9.37Z",
    style: {
      fill: "#BE9C79"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.87,382.57s-.88-3.35,2.58-9.28,5.79-9.4,5.79-9.4,4.37,7.1,1.24,12.94a85.94,85.94,0,0,1-8,11.78Z",
    style: {
      fill: "#BE9C79"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.15,277a99.36,99.36,0,0,1-1.33,10.77c-1.92,9.91-6.72,16.31-8.64,25.27s3.59,20.5,2.12,32-6,17.91-4.68,25.59,8,28.47,8,28.47",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 126.36,
    y1: 286.13,
    x2: 131.59,
    y2: 282.11,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 126.6,
    y1: 281.5,
    x2: 124.41,
    y2: 277.61,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.47,312.66s4.38-3.29,8.89-6.57",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.66,305.82a69.52,69.52,0,0,0-7.79-11.9",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.66,342.23A54.3,54.3,0,0,1,129,329.7",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.81,347.1a61.9,61.9,0,0,0-4.74-9c-2.56-3.77-2.93-4.26-2.93-4.26",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.62,370.66a58.62,58.62,0,0,1,3.95-8,51.33,51.33,0,0,1,5.11-6.7",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.45,388.61a14.79,14.79,0,0,1,1.31-7.68c1.82-3.53,3.89-8.15,4.75-10",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.91,324.25s-.37-2.17,2.14-5.74,4.18-5.66,4.18-5.66,2.39,4.74.09,8.28a54.49,54.49,0,0,1-5.73,7Z",
    style: {
      fill: "#BE9C79"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.68,337.07s-.37-2.17,2.14-5.75,4.18-5.65,4.18-5.65,2.39,4.74.09,8.28a54.49,54.49,0,0,1-5.73,7Z",
    style: {
      fill: "#BE9C79"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.74,327.92s-.6-2.12-4.42-4.25-6.21-3.28-6.21-3.28-.1,5.31,3.51,7.5a55.35,55.35,0,0,0,8.21,3.86Z",
    style: {
      fill: "#BE9C79"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.86,343S103,341,99,339.28s-6.53-2.61-6.53-2.61.46,5.29,4.28,7.08a54.28,54.28,0,0,0,8.57,3Z",
    style: {
      fill: "#BE9C79"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.88,360.71s-.37-2.18-3.94-4.7-5.84-3.92-5.84-3.92-.65,5.27,2.7,7.83a54.9,54.9,0,0,0,7.76,4.7Z",
    style: {
      fill: "#BE9C79"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.67,365s-.68-2.1,1.31-6,3.33-6.18,3.33-6.18,3,4.35,1.26,8.17a54.76,54.76,0,0,1-4.67,7.79Z",
    style: {
      fill: "#BE9C79"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.77,382.51s.25-2.19,3.67-4.91,5.6-4.24,5.6-4.24,1,5.22-2.25,8a54.5,54.5,0,0,1-7.47,5.14Z",
    style: {
      fill: "#BE9C79"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.87,377.1s-.38-2.18-4-4.69-5.83-3.92-5.83-3.92-.66,5.26,2.7,7.82a54.3,54.3,0,0,0,7.76,4.7Z",
    style: {
      fill: "#BE9C79"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.82,388.92s.19-2.2-2.63-5.54-4.65-5.27-4.65-5.27-2,4.93.63,8.25a54,54,0,0,0,6.31,6.52Z",
    style: {
      fill: "#BE9C79"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.54,323.74a62.45,62.45,0,0,0,2,6.61c2.28,6,6,9.5,8.16,14.91s0,13.25,2.15,20.3,5.68,10.58,5.71,15.54-1.92,18.72-1.92,18.72",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 96.02,
    y1: 329.36,
    x2: 92.31,
    y2: 327.41,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 95.37,
    y1: 326.49,
    x2: 96.32,
    y2: 323.81,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.48,345s-3.11-1.59-6.29-3.16",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.36,341a44.18,44.18,0,0,1,3.59-8.31",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.31,363.82A34.33,34.33,0,0,0,99.08,357",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.38,366.78a38.77,38.77,0,0,1,2-6.16c1.2-2.65,1.37-3,1.37-3",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.39,384.85a32.14,32.14,0,0,1,4-4.15,21.65,21.65,0,0,0,2.59-2.25",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.56,381.1a36.9,36.9,0,0,0-3.34-4.58,33.22,33.22,0,0,0-3.93-3.64",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.48,392.88a9.48,9.48,0,0,0-1.65-4.67c-1.53-2-3.33-4.69-4.06-5.75",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.71,397.42h31.77a0,0,0,0,1,0,0v23.29a3,3,0,0,1-3,3H103.76a3,3,0,0,1-3-3V397.42A0,0,0,0,1,100.71,397.42Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.2,401.56H100.71a2.48,2.48,0,0,1-2.48-2.48h0a2.48,2.48,0,0,1,2.48-2.49H132.2a2.48,2.48,0,0,1,2.49,2.49h0A2.48,2.48,0,0,1,132.2,401.56Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-2--inject-1--inject-92"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M287.1,211.25s-7.25,1-8.25,5-5.75,31-7.75,36.25-3,8.75-1.25,11.5,6,0,8.5-5.25,5-34.75,6.75-38.75A28.93,28.93,0,0,0,287.1,211.25Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.93,239.44c1.19-8.71,2.28-17.4,3.17-19.44a28.93,28.93,0,0,0,2-8.75s-7.25,1-8.25,5c-.57,2.29-2.38,12.14-4.19,21.12A16.72,16.72,0,0,0,281.93,239.44Z",
    style: {
      fill: "#BE9C79",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.1,394l.75,22.5s-9,5.5-13.5,7.5,3.25,3.25,6,3.25,7.75-2,10.75-2,5.75.75,5.75-3.5-.5-28-.5-28Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.85,421.75c0-.34,0-.82,0-1.39a66.61,66.61,0,0,1-12.49,1.89l-2.65-2.13c-2.56,1.46-5.38,3-7.35,3.88-4.5,2,3.25,3.25,6,3.25s7.75-2,10.75-2S294.85,426,294.85,421.75Z",
    style: {
      fill: "#BE9C79",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.85,395.5s3.25,21.75,5.75,26.5,7,9,9,9.75,5.25-1.75,2.5-7-7.5-9.75-8.75-13,1.25-17,1.25-17Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.6,431.75c2,.75,5.25-1.75,2.5-7a33.63,33.63,0,0,0-1.94-3.2,19.45,19.45,0,0,1-5.81.7c-1.51-.15-3.66-2.41-5.12-4.17A21.28,21.28,0,0,0,315.6,422C318.1,426.75,322.6,431,324.6,431.75Z",
    style: {
      fill: "#BE9C79",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.6,263.5s-1.5,13.5-2.5,23a222.7,222.7,0,0,0-1.25,32.75c.5,12.25,2.75,39.75,4.25,47.25a108.25,108.25,0,0,1,2,18.75c0,3.5.5,10,.5,10a15.37,15.37,0,0,0,7.25,2,35.92,35.92,0,0,0,7.25-.75s1-21.25,0-30.5-.5-41.75-.25-46.75,1-21,1-21,3.5,24.5,5.5,36.75,3.75,62.25,3.75,62.25a35.23,35.23,0,0,0,8.75,1.25,23.43,23.43,0,0,0,8.75-2s-1.75-38.75-1.75-48.25,3.5-53.5,1.5-61.5-6.25-21.25-6.25-21.25Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 291.41,
    y1: 288.16,
    x2: 295.96,
    y2: 300.45,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.6,205.5c-7.5-2.25-12.75.5-12.75.5s-9,3.5-12.75,5.25c-3.26,1.52-3.73,7.72-4.46,13.75-1.21,2.72-4.65,10.7-5.29,15.18a8.4,8.4,0,0,0,1.68,6.27c-1,5.43-1.85,10.41-2.18,12.8-.75,5.5,0,7.25,5.5,8.25s34.75.5,35.5-.5-.75-6.25,3.5-13.75,11.5-33.25,11.5-36.5S320.1,207.75,312.6,205.5Z",
    style: {
      fill: "#BE9C79",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 325.49,
    y1: 237.12,
    x2: 319.83,
    y2: 231.82,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.65,246.67s-6.36,3.18-11.67,2.83",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.1,205s-3.75,2.25-4,4.25-6.25,7.75-6.25,7.75,6-3,7.75-3.5,7.5-5.5,5.75-8.25S301.1,205,301.1,205Z",
    style: {
      fill: "#BE9C79",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.35,198s3,6.25,3,9.5v15.75l8.25-18.5c1-2.25,1-12.5,1-12.5S299.6,198.5,296.35,198Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.85,166.25s-3,3.5-3,7.5S286.79,184.54,285,186s-2.19,1.46-1.19,3a6,6,0,0,0,3.25,2s2.75,7.5,4.75,9,14.5-3.25,14.5-3.25,8.75-9.5,6.75-18.5S299.85,156.25,289.85,166.25Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.8,182.92c0,1-.36,1.8-.79,1.8s-.79-.81-.79-1.8.35-1.81.79-1.81S290.8,181.92,290.8,182.92Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.77,177.51s1.35-2.71,4.5.45",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.67,192.38a4.76,4.76,0,0,0,3.6-1.35",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.6,201.75l-5.5,7.75a17.68,17.68,0,0,0,3,7c2.5,3.5,4,7.75,4.25,6s-.25-5.75.25-8,2.75-8.5,2.75-8.5Z",
    style: {
      fill: "#BE9C79",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.6,230.5s4.13,29.62,3.75,33c-.83,7.36,10,11,11.5,6.25s-4.26-46.58-4.53-49.07c-.52-4.67-5.07-8.08-8.32-8.83",
    style: {
      fill: "#BE9C79",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.85,269.75c.92-2.92-.9-19.86-2.5-33.05a30,30,0,0,0-11.5,3.06c1.18,9,2.74,21.6,2.5,23.74C327.52,270.86,338.35,274.5,339.85,269.75Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.85,269.75s-1-7.25-4.25-8.75-11.75-.25-17.5-1.5a86.59,86.59,0,0,0-16.25-2.25c-4.25,0-13.25-.25-13.5.75s4.75,3.75,9.25,4.25a80.52,80.52,0,0,0,11.25,0c1.25,0,17,6.75,22.25,9S338.85,272.75,339.85,269.75Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "295.8 258.38 300.74 260.2 303.34 260.2",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.85,254.51c-2.85,0-4.64-.88-5.21-5.43a3.89,3.89,0,0,1,1.08-3.56c1.7-1.57,4.59-1,4.91-1a1.1,1.1,0,0,1-.45,2.15c-.54-.11-2.24-.27-3,.41-.13.13-.52.49-.38,1.67.45,3.62,1.12,3.69,4.6,3.44a1.1,1.1,0,1,1,.16,2.19C293,254.47,292.39,254.51,291.85,254.51Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300,257h-4.58a2.87,2.87,0,0,1-2.86-2.63l-1-11.73h12.3l-1,11.73A2.87,2.87,0,0,1,300,257Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "304.79 257.79 290.02 257.79 288.17 256.25 306.63 256.25 304.79 257.79",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.85,252.25s-7,1.25-9.93,5.95c-.75,1.2-1.07,8.3,1.68,10.55s6.75-4,8.75-7.5,4-7.75,4-7.75Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.35,159s-9.5-.5-8,8,14,4.5,16.5,12.25-4.25,25.75-3,26.5,16.75-2,18.75-5.25,5.5-12.25,3.5-25.5S306.6,154.75,292.35,159Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.05,251s1.05-6.46,2.3-8,8.85,4.13,8.85,4.13,1,2-.18,2.44a2.69,2.69,0,0,1-2.38-.49s.21,4.92-1.29,6.17-6.75.25-7.75-1.25S278.05,251,278.05,251Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 281.03,
    y1: 245.85,
    x2: 286.64,
    y2: 249.08,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.22,248.51s3.94,2.55,6.92,2.77",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.05,251a15.67,15.67,0,0,0,7.88,2.55",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-1--inject-1--inject-92"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M237.15,217.22s3.88.23,5.25,5.25,2,27.61,1.82,30.35,1.6,8,3.42,9.59,5.25,3.19,3.43,4.33-5,1.6-9.36-1.14-6.39-8.21-7.3-13.69.91-16.89-1.14-24S234.18,217.22,237.15,217.22Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.44,421.6a4.2,4.2,0,0,1-.73,2.44c-.73.74-17.12-.73-18.83-.73s-1.95-2-1.95-3.18S248.44,421.6,248.44,421.6Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.51,330.89s-3.67,16.14-4.89,21.27.73,18.34-1.47,29.83S235,408.64,235,410.84s13.93,9.78,13.44,10.76-10-.25-12.22-.49-5.87.24-7.58-.49-.25-4.4,0-6.36a236,236,0,0,0,1.47-24.45c0-11-2-26.4-1.23-31.78a123.51,123.51,0,0,0,.74-13.93c0-.74-2-13.21-2-13.21S238.42,329.92,245.51,330.89Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "238.91 414.26 236.22 421.11 240.86 422.09 243.55 417.44 238.91 414.26",
    style: {
      fill: "#BE9C79",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.08,413.07s-3.09,7.59-3.35,10.29,1.42,6,4.76,4.5,4.25-12.47,4.25-15S196.39,408.57,194.08,413.07Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213,333.58s8.56,14.67,7.09,17.85-8.07,9.53-11,19.8-12,34.48-14.42,41.32-4.65,13.2-.74,14.18,6.11-14.42,7.34-17.85,19.8-29.33,24-35.94,9-18.82,9-23-2.44-18.09-2.44-18.09S221.3,329.43,213,333.58Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "192.46 418.66 198.57 420.13 199.79 416.22 193.43 414.51 192.46 418.66",
    style: {
      fill: "#BE9C79",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.61,264.15a54.74,54.74,0,0,0-11.24,29.34c-1.23,17.6,15.64,42.05,15.64,42.05s24.21-4.4,33.74-1c0,0,7.34-20.05,4.4-38.87a97.79,97.79,0,0,0-12.22-33.5Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.18,292s5.58,16.76,8.84,32.12",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.57,285s2.8,8.38,4.19,13.5",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.07,166.34s3-.46,5.94,3.42,2.74,10,3.88,12.09,2.28,2.06,2.51,3.65-3,3-3,3-.68,7.3-2.05,10-4.57,2.74-6.17,2.28-5-1.82-5-1.82-1.14,9.58-.68,11.64,8.9,5,10.73,5.93,3.42,3.65,2.73,8,1.14,8.9,1.6,11.63,3.2,7.31.91,11.64-3.88,5.48-3.88,7.08,1.83,8,.69,9.58-26,2.05-28.53,2.05-3.87-5.93-4.33-7.3-5.71-22.13-7.53-27.15-2.05-14.61,2.28-16.43,12.55-3.43,14.38-8.45a25.32,25.32,0,0,0,.91-12.55c-.46-1.37-5.48-3.19-6.85-16.66S222.32,159,230.07,166.34Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.52,192.84c-.05.92-.5,1.64-1,1.61s-.88-.79-.83-1.71.5-1.64,1-1.61S237.57,191.92,237.52,192.84Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236,179.65l1.11,3a3,3,0,0,1-2.4.74",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.34,178.36s2-2,4.26-1.85",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.3,187.1a4.58,4.58,0,0,0,5.47-4.56c.46-5.48,1.23-9.07,5.79-9.52s4.48.39,9.5-1.21,7.53-12.09,2.28-15.06-10.27,2.06-13.69,3.65-7.76-3.88-12.78-.45-3.19,7.76-4.79,10.49-5.48,7.53-3.19,13,8.67,13.69,11,11.87S217.3,187.1,217.3,187.1Z",
    style: {
      fill: "#BE9C79",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "222.82 176.85 217.24 176.15 217.07 178.24 222.47 179.29 222.82 176.85",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.17,189.38s-1.36-4.1-4.1-3.88-1.37,6.17.91,8.45,4.79-.92,4.79-.92",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.71,184.14s-4.11-2.51-6.39,0-1.82,10.49,1.83,12.77a5.24,5.24,0,0,0,8.21-4.79A10.75,10.75,0,0,0,207.71,184.14Z",
    style: {
      fill: "#BE9C79",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239,224.53c.69-4.34-.91-7.08-2.73-8-.71-.35-2.39-1-4.23-1.8-.74,4.36-3.1,11.37-10.61,11.84-8,.5-14.72-7.69-17.81-12.2-1.25.43-2.43.83-3.41,1.25a3.62,3.62,0,0,0-.74.42c2.63,3.71,6.53,10.22,7.13,16.92a9.41,9.41,0,0,1-5.53,9.82c2,7.36,4.11,15.58,4.39,16.42.46,1.37-.53,6.32,2,6.32s29.74.53,30.88-1.07-.69-8-.69-9.58,1.6-2.74,3.88-7.08-.45-8.9-.91-11.64S238.29,228.86,239,224.53Z",
    style: {
      fill: "#BE9C79",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200,216.77s-4.79-.23-6.84,5.7-9.36,49.75-8.9,52.26,8.67-1.37,9.58-3.42,10-34.69,10-34.69",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.91,264.23s22.14-9.81,25.79-13.46,2.74-6.85,3.88-8.45a43.33,43.33,0,0,0,3-3.87c.92-1.6,1.83-1.37,1.83.22S223,241.41,223,242.1v.68s5.7-2.28,7.07-2.74,3.43-3,3.66-1.37-2.52,2.74-2.74,4.8,0,4.56-1.37,6.16-6.16,3.88-8.45,4.56-16,9.36-22.13,14.15-11.87,8.67-14.38,7.53.69-8.9.69-8.9",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.21,265.12s1.27-3.16,1-4.43-2.48-.58-3,1-.34,2.19.16,2.19S256.21,265.12,256.21,265.12Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.31,264.74a23.18,23.18,0,0,0,2.4,2.28c1.52,1.27,4.81,1.65,4.81,1.65s-3.42-3-4.05-3.67S243.31,264.74,243.31,264.74Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256,264.69s-1,3.09-2,4-4.3-.13-6.32-1.52-3-2.79-1.9-2.79S256,264.69,256,264.69Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.86,264.87a30.23,30.23,0,0,0,5.57,4.3",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.74,264s1.31,3.27,2.83,4",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245,261.48c-2.79,0-4.54-.86-5.09-5.31a3.79,3.79,0,0,1,1-3.48c1.66-1.53,4.48-1,4.8-.93a1.08,1.08,0,0,1-.44,2.11c-.53-.11-2.19-.27-2.91.4-.13.12-.52.48-.37,1.63.44,3.54,1.09,3.61,4.5,3.36a1.08,1.08,0,1,1,.15,2.15C246.08,261.45,245.52,261.48,245,261.48Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.91,263.94h-4.48a2.8,2.8,0,0,1-2.79-2.57l-1-11.47h12l-1,11.47A2.81,2.81,0,0,1,252.91,263.94Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "257.64 264.69 243.2 264.69 241.39 263.18 259.44 263.18 257.64 264.69",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Speech-bubble--inject-1--inject-92"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M275.07,115.57H223.39a5,5,0,0,0-5,5v20.16a5,5,0,0,0,5,5h27l-4.17,9.6,12.1-9.6h16.71a5,5,0,0,0,5-5V120.57A5,5,0,0,0,275.07,115.57Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239,130.19a2.29,2.29,0,1,1-2.29-2.28A2.28,2.28,0,0,1,239,130.19Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.83,130.19a2.29,2.29,0,1,1-2.29-2.28A2.28,2.28,0,0,1,250.83,130.19Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.71,130.19a2.29,2.29,0,1,1-2.28-2.28A2.28,2.28,0,0,1,262.71,130.19Z",
    style: {
      fill: "#fff"
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactImg);
export default __webpack_public_path__ + "static/media/contact-img.89690b668b285da9c4b560f0ac676c2d.svg";
export { ForwardRef as ReactComponent };